module.exports = __webpack_public_path__ + "media/src/img/payment/tochkabank-logo-e4d847ce0ba42b41b80658f9dc33f23f.svg";